import React from 'react';

import { Grid } from '@mui/material';

import { IOrder } from '../../../types/Order';
import {
  address,
  formatDate,
  formatter,
  getWindowDimensions,
  lender,
} from '../../utils/helpers';

interface IProps {
  order?: IOrder;
  hideSigners?: boolean;
  cancelOrder?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

function OrderDetailsAccordionCard(props: IProps) {
  const { order } = props;

  const windowSize = getWindowDimensions().width;
  const padding = windowSize > 1024 ? 1 : 0;

  return (
    <Grid container sx={{ padding: padding }}>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={windowSize > 1024 ? 3.5 : 4.1}>
            <div className='order-label'>LOAN NUMBER</div>
            <div className='order-value'>{order?.LoanNumber}</div>
          </Grid>
          <Grid item xs={windowSize > 400 ? 2.5 : 4}>
            <div className='order-label'>ORDER TYPE</div>
            <div className='order-value'>{order?.OrderType?.Name}</div>
          </Grid>
          <Grid item xs={windowSize > 1024 ? 3 : 2.6}>
            <div className='order-label'>CREATED DATE</div>
            <div className='order-value'>
              {formatDate(order?.CreatedAt, 'ddd, MMM DD, YYYY')}
            </div>
          </Grid>
          <Grid item xs={windowSize > 1024 ? 3 : 2.6}>
            <div className='order-label'>CLOSING DATE</div>
            <div className='order-value'>
              {formatDate(
                order?.OrderDetails?.SigningDate,
                'ddd, MMM DD, YYYY',
                order?.OrderDetails?.SigningDateTimeZone
              )}
            </div>
          </Grid>
        </Grid>
        <Grid container sx={{ paddingTop: 3 }}>
          <Grid item xs={windowSize > 1024 ? 3.5 : 4.1}>
            <div className='order-label'>PROPERTY ADDRESS</div>
            <div className='order-value'>{address(order)}</div>
          </Grid>
          <Grid item xs={2.5}>
            <div className='order-label'>LOAN AMOUNT</div>
            <div className='order-value'>
              {order?.OrderDetails?.NewLoans &&
              order.OrderDetails.NewLoans[0]?.LoanAmount
                ? formatter.format(
                    parseInt(order?.OrderDetails?.NewLoans[0]?.LoanAmount)
                  )
                : ''}
            </div>
          </Grid>
          <Grid item xs={windowSize > 1024 ? 3 : 2.6}>
            <div className='order-label'>LOAN TYPE</div>
            <div className='order-value'>
              {order?.OrderDetails?.NewLoans &&
              order.OrderDetails.NewLoans[0]?.Type
                ? order?.OrderDetails?.NewLoans[0]?.Type
                : ''}
            </div>
          </Grid>
          <Grid item xs={windowSize > 1024 ? 3 : 2.6}>
            <div className='order-label'>LENDER</div>
            <div className='order-value'>{lender(order)}</div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default OrderDetailsAccordionCard;
